module.exports = __webpack_public_path__ + "img/oriandes.3715f48e.jpg";